import './MiniContainer.css'

const MiniContainer = (props) => {
    return (
        <div className='mini-container'>
            {props.children}
        </div>
    )
}

export default MiniContainer